export default (str: string, breakTag = '<br>'): string => str.replace(/(?:\r\n|\r|\n)/g, breakTag);
